// TODO: store css classes especially used in business logic here

export const CHECKOUT_CONTAINER = 'checkout-container';
export const CHECKOUT_CONTAINER_MOBILE = 'checkout-container-mobile';
export const MOBILE_CHECKOUT = 'checkout-mobile';
